import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ServicesPage from '../pages/services/page';
import IphoneServicePage from '../pages/services/iphone/page';
import IpadServicePage from '../pages/services/ipad/page';
import MacServicePage from '../pages/services/mac/page';
import DataRecoveryPage from '../pages/services/data-recovery/page';
import PricingPage from '../pages/pricing/page';
import NewsPage from '../pages/news/page';
import NewsDetailPage from '../pages/news/detail/page';
import CasesPage from '../pages/cases/page';
import FAQPage from '../pages/faq/page';
import ContactPage from '../pages/contact/page';
import AdminLoginPage from '../pages/admin/login/page';
import AdminDashboardPage from '../pages/admin/dashboard/page';
import AdminPricingPage from '../pages/admin/pricing/page';
import AdminNewsPage from '../pages/admin/news/page';
import AdminPagesPage from '../pages/admin/pages/page';
import UploadImagesPage from '../pages/admin/upload-images/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/services/iphone', element: <IphoneServicePage /> },
  { path: '/services/ipad', element: <IpadServicePage /> },
  { path: '/services/mac', element: <MacServicePage /> },
  { path: '/services/data-recovery', element: <DataRecoveryPage /> },
  { path: '/pricing', element: <PricingPage /> },
  { path: '/news', element: <NewsPage /> },
  { path: '/news/:id', element: <NewsDetailPage /> },
  { path: '/cases', element: <CasesPage /> },
  { path: '/faq', element: <FAQPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/admin', element: <AdminLoginPage /> },
  { path: '/admin/dashboard', element: <AdminDashboardPage /> },
  { path: '/admin/pricing', element: <AdminPricingPage /> },
  { path: '/admin/news', element: <AdminNewsPage /> },
  { path: '/admin/pages', element: <AdminPagesPage /> },
  { path: '/admin/upload-images', element: <UploadImagesPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
